/** Max shape for ITR Ratio: 3 integer digits + optional `.` + 2 decimal digits (e.g. 999.99). */
export const ITR_RATIO_MAX_INTEGER_DIGITS = 3
export const ITR_RATIO_MAX_DECIMAL_DIGITS = 2

/**
 * Sanitize Company Config "ITR Ratio" while typing.
 * Digits + at most one `.`; max 3 digits before the decimal and 2 after.
 * Extra digits are dropped (not rewritten to a max value).
 */
export function sanitizeItrRatioInput(raw: string): string {
  const stripped = String(raw ?? '').replace(/[^\d.]/g, '')
  if (!stripped) return ''

  const firstDot = stripped.indexOf('.')
  const normalized =
    firstDot === -1
      ? stripped
      : stripped.slice(0, firstDot + 1) + stripped.slice(firstDot + 1).replace(/\./g, '')

  const hasDot = normalized.includes('.')
  const [intRaw = '', fracRaw = ''] = normalized.split('.')
  const intPart = intRaw.slice(0, ITR_RATIO_MAX_INTEGER_DIGITS)
  const fracPart = fracRaw.slice(0, ITR_RATIO_MAX_DECIMAL_DIGITS)

  if (hasDot) return `${intPart}.${fracPart}`
  return intPart
}
